/**
 * Shared stylesheet for printable monthly billing reports (A4).
 */
export const MONTHLY_REPORT_CSS_STYLE = `
body {
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Georgia, "Times New Roman", serif;
}

.report {
    color: black;
    background-color: white;
    padding: 20px 10px;
}

.report .title {
    margin-bottom: 10px;
}

.report h2 {
    text-align: center;
    margin: 0px 0px 5px 0px;
    font-size: 18px;
}

.report .brief {
    font-weight: bold;
}

.report .brief .small {
    font-weight: normal;
    font-size: 80%;
    opacity: .8;
}

.report .brief .data {
    padding-right: 8px;
    margin-right: 8px;
    border-right: 1px solid #999;
}

.report .brief .data:last-child {
    border-right: none;
}

.report table {
    width: 100%;
    border: 1px solid #ddd;
}

.report table tr {
    border-bottom: none !important;
}

.report table tr:nth-child(odd) {
    background-color: #ddd;
}

.report table th {
    padding: 3px 5px;
    height: 25px;
}

.report table th:first-child {
    text-align: left;
}

.report table td {
    padding: 3px 5px;
}
`.trim();

/**
 * Returns the CSS payload used for printable monthly report documents.
 */
export const monthlyStyle = (): string => {
    return MONTHLY_REPORT_CSS_STYLE;
};
